import type { BiDefaults, Logger, ReportProps } from '.';

export class BiLogger {
    private logger: Logger;
    private defaults: BiDefaults;

    constructor(logger: Logger, defaults?: BiDefaults) {
        this.logger = logger;
        this.defaults = defaults || {};
    }

    async report(reportProps: ReportProps) {
        this.logger.report({
            ...reportProps,
            params: {
                ...reportProps.params,
                ...this.defaults,
            },
        });
    }
}

export default BiLogger;
